/**
 * Modules whose operations are available even when the module itself is not
 * explicitly enabled in the user's context (auth, session, navigation, and
 * cross-cutting settings/profile operations).
 */
export const ENTITLEMENT_EXEMPT_MODULES = [
    'AUTH',
    'NAVIGATION',
    'SETTINGS',
];
